<template lang="html">
  <div>
    <select v-model="paletteIndex">
      <option v-for="(palette, index) in colorPalettes" :key="index" :value="index">{{palette.name}}</option>
    </select>
    <div class="select">
      <div v-for="color in colorPalettes[paletteIndex].colors" :key="color" class="bg_transparent" style="display: inline-block;">
        <button type="button" :style="{background: 'rgba(' + color + ')'}" style="border: 1px solid #eee;width: 22px;height: 22px;padding: 0;margin: 0;" @click="$emit('change', {r: color[0], g: color[1], b: color[2], a: color[3]})">&nbsp;</button>
      </div>
    </div>
    <div v-if="paletteIndex === 0" class="select-controls">
      <button type="button" class="btn-icon" @click="saveCurrColor()" title="Save Color"><i class="icon-favorite"></i></button>
      <button type="button" class="btn-icon" @click="clearSavedColors()" title="Clear Saved Colors"><i class="icon-delete"></i></button>
    </div>
  </div>
</template>

<script>
import GameStudio from '@/assets/js/GameStudio.js'
const UtilEditor = window.UtilEditor;

export default {
  props: ['value'],
  emits: ['change'],
  data() {
    return {
      paletteIndex: 0
    };
  },
  computed: {
    colorPalettes() {
      const palettes = [];
      GameStudio.getFilesWithExtensions(['.gpl']).forEach(x => palettes.push({
        name: x.name,
        colors: UtilEditor.parseGimpPalette(x.data)
      }));
      palettes.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
      palettes.unshift({
        name: 'Saved Colors',
        colors: this.$store.preferences.imageEditorSavedColors
      });
      return palettes;
    }
  },
  methods: {
    saveCurrColor() {
      const rgba = this.value;
      this.$store.preferences.imageEditorSavedColors.push([rgba.r, rgba.g, rgba.b, rgba.a]);
      GameStudio.savePreferences();
    },
    clearSavedColors() {
      this.$store.preferences.imageEditorSavedColors = [];
      GameStudio.savePreferences();
    }
  }
}
</script>

<style lang="css" scoped>
</style>
